const brandConstants: any = {
  COLOR_PRIMARY: '#1C69D4',
  COLOR_PRIMARY_LIGHT: '#88DFFF',
  COLOR_PRIMARY_DISABLED: '#D2D2D2',
  COLOR_SECONDARY: '#262626',
  COLOR_SECONDARY_DARK: '#4D4D4D',
  COLOR_LIGHT_GREY: '#E6E6E6',
  COLOR_WHITE: '#FFFFFF',
  COLOR_BG_ALTERNATE: '#F4F4F4',
  COLOR_BG_THIRD: '#EBEBEC',
  COLOR_BG_FOURTH: '#000000',
  COLOR_THIRD: '#8E8E8E',
  COLOR_THIRD_HOVER: '#8298b3',
  COLOR_FOURTH: '#F2F2F2',
  COLOR_FIFTH: '#DC1226',
  COLOR_SIXTH: '#bbbbbb',
  COLOR_SEVENTH: '#00DA09',
  COLOR_EIGHT: '#CCCCCC',
  COLOR_ERROR: '#FF0000',
  COLOR_DARK_GREY: '#656565',


  PRIMARY_FONT: ['BMWTypeNextTTF', 'Helvetica', 'sans-serif'].join(','),
  PRIMARY_FONT_BOLD: ['BMWTypeNextBoldTTF', 'Arial-Bold', 'sans-serif'].join(','),
  PRIMARY_FONT_LIGHT: ['BMWTypeNextLightTTF', 'Helvetica', 'sans-serif'].join(','),
  HEAVY_FONT: ['Boris-Black-Bloxx', 'Avenir-Black', 'Arial-Bold', 'sans-serif'].join(','),

  FONT_XXS: 10,
  FONT_XS: 12,
  FONT_SM: 14,
  FONT_MD: 16,
  FONT_LG: 20,
  FONT_XL: 24,
  FONT_XXL: 36,
};

export const DEFAULT_SPACING = 10;

export const BREAKPOINTS = {
  xs: 0,
  sm: 768,
  md: 960,
  lg: 1280,
  xl: 1920,
};

export default brandConstants;
